<script setup lang="ts">
import { PurchaseAgainProps } from "./PurchaseAgain.props"

withDefaults(defineProps<PurchaseAgainProps>(), {
  theme: "white"
})
</script>

<template>
  <div
    class="purchase-again-wrapper px-4 py-5 md:shadow-01"
    :class="`bg-${theme}`"
  >
    <p v-if="title" class="elephant-bold text-green-main mb-6">
      {{ title }}
    </p>

    <GAItem
      id="purchase-again"
      :item="orders.map((order) => order.products).flat()"
    >
      <GAViewItemList> </GAViewItemList>
    </GAItem>

    <div
      v-if="orders"
      class="
        -mx-4
        -mb-4
        flex flex-col
        gap-7
        px-4
        pb-4
        md:max-h-[450px]
        md:overflow-y-auto
      "
    >
      <div v-for="(order, index) in orders" :key="`order${index}`">
        <p
          v-if="order.deliveryDate"
          class="beaver md:pig text-wireframe-grey-70 mb-3"
        >
          <span class="beaver-bold md:pig-bold">
            {{ $t("productBlocks.purchaseAgain.delievered") }}
          </span>
          {{ order.deliveryDate }}
        </p>
        <UtilsMarkdown
          v-else-if="order.statusText"
          class="text-wireframe-grey-70 mb-3"
          :content="order.statusText"
        />

        <div class="flex flex-col gap-3">
          <ProductTileOverallSearch
            v-for="(product, index) in order.products"
            :key="`product${index}`"
            v-bind="product"
          />
        </div>
      </div>
    </div>
  </div>
</template>
